module.exports = __webpack_public_path__ + "img/retrieved.145d92e0.png";